// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-ecommerce-layout',
    props: {
        widthMode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
    computed: {
        getStickyMenu() {
            return this.$host.store.get("session").stickyMenu;
        },
    },
});
// #endregion
